var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: "赛程",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "popover", staticStyle: { "flex-direction": "column" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.reqLoading,
                  expression: "reqLoading"
                }
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "home_team_name",
                  label: "主队",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "home_score",
                  label: "主队得分",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "away_team_name",
                  label: "客队",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "away_score",
                  label: "客队得分",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "location", label: "比赛场地", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        row.status == 0
                          ? _c("span", [_vm._v("未开始")])
                          : _vm._e(),
                        row.status == 1
                          ? _c("span", [_vm._v("进行中")])
                          : _vm._e(),
                        row.status == 2
                          ? _c("span", [_vm._v("已结束")])
                          : _vm._e(),
                        row.status == 3
                          ? _c("span", [_vm._v("已取消")])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "winnerName", label: "胜利队" }
              }),
              _c("el-table-column", {
                attrs: { prop: "match_duration", label: "比赛时长(分钟)" }
              }),
              _c("el-table-column", {
                attrs: { prop: "round_name", label: "比赛轮次" }
              }),
              _c("el-table-column", {
                attrs: { prop: "match_phase", label: "比赛阶段" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        row.match_phase == "regular"
                          ? _c("span", [_vm._v("常规赛")])
                          : row.match_phase == "extra_time"
                          ? _c("span", [_vm._v("加时赛")])
                          : row.match_phase == "penalty"
                          ? _c("span", [_vm._v("已完成")])
                          : row.match_phase == "finished"
                          ? _c("span", [_vm._v("已完成")])
                          : _c("span", [_vm._v("/")])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "match_time", label: "比赛时间" }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "100",
                  align: "center",
                  fixed: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return _c("div", { staticClass: "x-c" }, [
                        _c(
                          "div",
                          {
                            staticClass: "controlsBtn",
                            on: {
                              click: function($event) {
                                return _vm.$refs.lineupBoard.init(row.id)
                              }
                            }
                          },
                          [_vm._v("比赛布阵")]
                        )
                      ])
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm.tableData.length
            ? _c("el-pagination", {
                attrs: {
                  layout: "total, prev, pager, next",
                  "current-page": _vm.paramsData.page,
                  total: _vm.total,
                  "page-size": 10
                },
                on: { "current-change": _vm.getScoreListFn }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      ),
      _c("lineupBoard", { ref: "lineupBoard", attrs: { teamId: _vm.teamId } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }